const timer = {
  interval: 0,
  currentTime: 0,
  endTime: 0,


  /**
   * Starts the timer
   * @param {Number} endTime - The time, in seconds, the timer should stop
   * @param {Function} endCallback- A callback for when the time is up
   * @returns {undefined} undefined
   */
  start(endTime, updateCallback, endCallback) {
    this.endTime = endTime;
    this.updateCallback = updateCallback;
    this.endCallback = endCallback;
    this.tickFunction = this.tick.bind(this);
    this.interval = setInterval(this.tickFunction, 1000);
  },


  /**
   * Pauses the timer
   * @returns {undefined} undefined
   */
  pause() {
    clearInterval(this.interval);
  },


  /**
   * Unpauses the timer
   * @returns {undefined} undefined
   */
  unPause() {
    this.interval = setInterval(this.tickFunction, 1000);
  },


  /**
   * Called when the timer 'ticks'
   * @returns {undefined} undefined
   */
  tick() {
    this.currentTime++;

    if (this.updateCallback) {
      this.updateCallback(this.currentTime);
    }

    if (this.currentTime >= this.endTime) {
      if (this.endCallback) {
        this.endCallback();
      }

      this.stop();
    }
  },


  /**
   * Stops the timer
   * @returns {undefined} undefined
   */
  stop() {
    this.currentTime = 0;
    this.endTime = 0;
    this.updateCallback = null;
    this.endCallback = null;
    clearInterval(this.interval);
  },
};

export default timer;



/** WEBPACK FOOTER **
 ** ./assets/js/src/lib/timer.js
 **/